export const Bio = {
  name: "Mannat Saluja",
  roles: [
    "Customer Success Mgr.",
    "Project Manager",
    "Data Analyst",
    "Classical Dancer",
    "Rock Climber",
    "Dog Lover",
    "Travel Enthusiast",
  ],
  description:
    "I am a Customer Success Manager with a Master's degree in Engineering Management. The purpose of this website is to showcase my technical skills, projects that I have utilized those skills on, and my professional experience to date. I plan to expand this website to provide its viewers with a broader glance into who I am and what I do. Be sure to visit frequently to learn more about me.",
  resume: "/Resume_MannatSaluja_2025.pdf",
  coverLetter: "/Cover Letter_Mannat Saluja",
  linkedin: "https://www.linkedin.com/in/msaluja",
  insta: "https://www.instagram.com/salujamannat",
  facebook: "https://www.facebook.com/salujamannat",
};

export const skills = [
  {
    title: "Customer Success",
    skills: [
      {
        name: "Digital Sales",
        image: "",
      },
      {
        name: "SAAS",
        image: "",
      },
      {
        name: "Upsell",
        image: "",
      },
      {
        name: "Account Renewals",
        image: "",
      },
      {
        name: "Gainsight",
        image: "",
      },
      {
        name: "Medallia",
        image: "",
      },
      {
        name: "Gong",
        image: "",
      },
      {
        name: "ServiceNow",
        image: "",
      },
      {
        name: "Salesforce.com",
        image: "",
      },
    ],
  },
  {
    title: "Project Management",
    skills: [
      {
        name: "MS Project",
        image: "",
      },
      {
        name: "Monday.com",
        image: "",
      },
      {
        name: "Project Estimation",
        image: "",
      },
      {
        name: "Sharepoint",
        image: "",
      },
      {
        name: "OneNote",
        image: "",
      },
      {
        name: "Asana",
        image: "",
      },
      {
        name: "Notion",
        image: "",
      },
      {
        name: "Slack",
        image: "",
      },
      {
        name: "Hubspot",
        image: "",
      },
      {
        name: "Treasury Management",
        image: "",
      },
      {
        name: "Visio",
        image: "",
      },
      {
        name: "Totango",
        image: "",
      },
    ],
  },
  {
    title: "Technical",
    skills: [
      {
        name: "SAP Analytics Cloud",
        image: "",
      },
      {
        name: "MS Office",
        image: "",
      },
      {
        name: "Loyalty Analytics",
        image: "",
      },
      {
        name: "VS Code",
        image: "",
      },
      {
        name: "JIRA",
        image: "",
      },
      {
        name: "Confluence",
        image: "",
      },
      {
        name: "Tableau",
        image: "",
      },
      {
        name: "Power BI",
        image: "",
      },
      {
        name: "Qualtrics",
        image: "",
      },
      {
        name: "NetSuite",
        image: "",
      },
      {
        name: "Snowflake",
        image: "",
      },
      {
        name: "Google Analytics",
        image: "",
      },
      {
        name: "Advanced Excel",
        image: "",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "/images/PrimenumbersTechnologiesPvtLtd.webp",
    role: "Business Development Intern",
    company: "Primenumbers Technologies Pvt Ltd",
    date: "Jan 2019 - Jul 2019",
    desc: "Managed high-volume customer interactions via phone and CRM tools, leveraging negotiation strategies and needs-based assessments to drive customer alignment and satisfaction.",
    skills: [""],
  },
  {
    id: 1,
    img: "/images/KPMG.png",
    role: "Risk Compliance and Technology Assurance Analyst",
    company: "KPMG",
    date: "Aug 2019 - Jan 2021",
    desc: "Executed ITGC, ITAC, and business process testing as part of audit procedures at KPMG, identifying control deficiencies and documenting findings to support client reporting and compliance assessments.",
    skills: [""],
  },
  {
    id: 2,
    img: "/images/CapillaryTechnologiesPvtLtd.jpeg",
    role: "Customer Success Associate",
    company: "Capillary Technologies Pvt Ltd",
    date: "Jan 2021 - May 2021",
    desc: "Led client success initiatives across onboarding, CRM strategy, and loyalty program redesign—driving adoption, optimizing customer journeys, and increasing CSAT and NPS through data-driven insights and targeted lifecycle campaigns.",
    skills: [""],
  },
  {
    id: 3,
    img: "/images/SAP.svg",
    role: "Data Analyst Intern",
    company: "SAP America",
    date: "Apr 2024 - Apr 2025",
    desc: "Leveraged SAP Analytics Cloud to analyze adoption trends and performance across 9 market units, translating complex data into strategic insights that guided North America Solution Advisory leadership on growth, efficiency, and engagement for 1,000+ employees.",
    skills: [""],
  },
  {
    id: 4,
    img: "/images/SAP.svg",
    role: "Customer Success Associate Intern",
    company: "SAP America",
    date: "Feb 2023 - Dec 2023",
    desc: "Enabled strategic planning and operational support for the Customer Success org by automating KPI dashboards across 7+ pillars in SAP Analytics Cloud - boosting efficiency, visibility, and data-driven decision-making for key stakeholders.",
    skills: [""],
  },
  {
    id: 5,
    img: "/images/TIS.png",
    role: "Customer Success Manager",
    company: "Treasury Intelligence Solutions",
    date: "Apr 2024 - Apr 2025",
    desc: "Owned the full post-sale journey for mid-market to enterprise clients - leading onboarding, QBRs, and renewals, while driving platform adoption, uncovering growth opportunities, and securing key account retention through proactive, insight-led engagement.",
    skills: [""],
  },
  {
    id: 6,
    img: "/images/service_titan.png",
    role: "Customer Success Manager",
    company: "Service Titan",
    date: "Aug 2025 - Present",
    desc: "Manage 80+ business accounts, ensuring smooth onboarding, strong adoption, and high account health. Drive revenue and productivity through tailored training and workflow improvements. Leverage tools like Salesforce, Gainsight, Gong, and Tableau to track performance and proactively meet customer needs. Consistently exceed KPIs by identifying upsell opportunities aligned with customer goals.",
    skills: [""],
  },
].sort((a, b) => b.id - a.id);

export const education = [
  {
    id: 0,
    img: "/images/ManipalLogo.png",
    school: "Manipal Institute of Technology",
    grade: "3.0/4.0",
    degree: "Bachelor of Engineering in Civil Engineering",
    desc: (
      <p>
        I completed my bachelor's degree in Civil Engineering, gaining a strong
        foundation in structural analysis, project planning, and technical
        problem-solving. Developed analytical thinking, teamwork, and on-site
        execution skills through hands-on labs, design projects, and fieldwork.
      </p>
    ),
  },
  {
    id: 1,
    img: "/images/UMassAmherst.png",
    school: "University of Massachusetts, Amherst",
    grade: "3.7/4.0",
    degree: "Master of Science in Engineering Management",
    desc: (
      <p>
        I completed my masters degree with a major in Engineering Management
        which equipped me with a blend of technical problem-solving, data
        analytics, and business strategy. Developed skills in project
        management, process optimization, and cross-functional leadership
        through hands-on coursework and real-world applications.
      </p>
    ),
  },
].sort((a, b) => b.id - a.id);

export const projects = [
  {
    id: 0,
    title: "Customer Discovery",
    description:
      "Interviewed customers using design thinking frameworks to model customer empathy maps and presented Business Model Canvas of a self-help startup for a market size of $100M.",
    image: "images/Discovery.jpg",
    category: "Design Thinking",
    tags: [
      "Customer Research & Interviewing",
      "Market Sizing & Validation",
      "Problem-Solution Fit Analysis",
    ],
  },
  {
    id: 1,
    title: "Scalability Strategy",
    description:
      "Introduced essential managerial challenges and cutting-edge approach for a new product scalability, using various product management frameworks/tools to determine cost breakdown, revenue stream and a plan for operation management",
    image: "images/Scalability.jpg",
    category: "Product Management",
    tags: [
      "Revenue Modelling",
      "Operational Planning",
      "Cost Structure Analysis",
      "Strategic Storytelling",
    ],
  },
  {
    id: 2,
    title: "Health Monitoring",
    description:
      "Developed a monitoring system to identify patient metrics and process tracking by utilizing alternative design analysis and decision-based design assessing technical stability for 10+ patients.",
    image: "images/HealthMonitoring.jpg",
    category: "Project Management",
    tags: [
      "System Design",
      "Technical Assessment",
      "User Centered Design",
      "Process Tracking",
      "Data Analysis",
    ],
  },
].sort((a, b) => b.id - a.id);

export const certifications = [
  {
    id: 0,
    title: "Enterprise Design Thinking Practitioner by IBM",
    description:
      "Earned IBM’s Enterprise Design Thinking Practitioner certification, demonstrating proficiency in user-centered problem-solving, stakeholder alignment, and iterative solution design. Applied key principles like Hills, Playbacks, and Sponsor Users to drive collaboration and deliver meaningful, scalable solutions.",
    image: "/images/DesignThinkingCertification.png",
  },
  {
    id: 1,
    title: "Customer Success Management Fundamentals",
    description:
      "Completed LinkedIn's Customer Success Management Fundamentals course, covering core principles of customer success, including onboarding, customer journey mapping, retention strategies, and metrics like NPS and churn. Gained insights into building long-term client relationships, driving product adoption, and delivering measurable business value.",
    image: "/images/CSFundamentalsCertificate.jpeg",
  },
  {
    id: 2,
    title: "Engineering Project Management and Leadership",
    description:
      "Developed foundational skills in managing engineering projects from initiation to delivery, including planning, resource allocation, risk management, and stakeholder communication. Emphasized leadership principles to motivate teams, resolve conflicts, and drive project success in technical environments.",
    image: "images/PMDegree.jpg",
  },
].sort((a, b) => b.id - a.id);

export const volunteering = [
  {
    id: 0,
    title: "Engineering Project Management and Leadership",
    description:
      "Developed foundational skills in managing engineering projects from initiation to delivery, including planning, resource allocation, risk management, and stakeholder communication. Emphasized leadership principles to motivate teams, resolve conflicts, and drive project success in technical environments.",
    image: "images/PMDegree.jpg",
  },
].sort((a, b) => b.id - a.id);

export const extracurricular = [
  {
    id: 0,
    title: "Engineering Project Management and Leadership",
    description:
      "Developed foundational skills in managing engineering projects from initiation to delivery, including planning, resource allocation, risk management, and stakeholder communication. Emphasized leadership principles to motivate teams, resolve conflicts, and drive project success in technical environments.",
    image: "images/PMDegree.jpg",
  },
].sort((a, b) => b.id - a.id);
